 // PATH: SaberpDeals/frontend/src/lib/ledgerApi.ts
import { api } from './api';

export interface CustomerBreakdown {
    customer: string;
    sales: number;
    technical: number;
    house: number;
    total: number;
}

export interface LedgerEntry {
    kind: 'Company' | 'Owner' | 'Person';
    personId: number | null;
    name: string;
    currency: 'USD' | 'IQD';
    total: number;
    sales: number;
    technical: number;
    newBusiness: number;
    renewal: number;
    support: number;
    dealCount: number;
    customers: CustomerBreakdown[];
}

export const ledgerApi = {
    async list(): Promise<LedgerEntry[]> {
        const { data } = await api.get('/api/deals/ledger');
        return data;
    },
};